import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CommentsPage = () => {
    const [comments, setComments] = useState([]);
    const [error, setError] = useState('');

    const fetchComments = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/comments`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setComments(response.data);
        } catch (err) {
            setError('Failed to fetch comments');
        }
    };

    useEffect(() => {
        fetchComments();
    }, []);

    const handleDelete = async (commentId) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/admin/comments/${commentId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // Refetch comments after deletion
            fetchComments();
        } catch (err) {
            setError('Failed to delete comment');
        }
    };

    if (error) {
        return <div className="text-red-500">{error}</div>;
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl lg:text-3xl font-bold text-slate-900">Comments Management</h1>
                <p className="text-slate-500 mt-1">Moderate comments on the platform ({comments.length} total)</p>
            </div>

            {error && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
                    {error}
                </div>
            )}

            <div className="card overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr>
                                <th className="text-left" style={{ width: '40%' }}>Content</th>
                                <th className="text-left" style={{ width: '20%' }}>Author</th>
                                <th className="text-left" style={{ width: '20%' }}>Post ID</th>
                                <th className="text-center" style={{ width: '20%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center py-8 text-slate-500">
                                        No comments found
                                    </td>
                                </tr>
                            ) : (
                                comments.map((comment) => (
                                    <tr key={comment.id || comment._id}>
                                        <td>
                                            <p className="text-sm text-slate-900">{comment.content.substring(0, 100)}</p>
                                            <p className="text-xs text-slate-500 mt-1">
                                                {new Date(comment.created_at).toLocaleDateString()}
                                            </p>
                                        </td>
                                        <td>
                                            <p className="font-medium text-slate-900">{comment.author_name}</p>
                                        </td>
                                        <td>
                                            <code className="text-xs bg-slate-100 px-2 py-1 rounded text-slate-700">
                                                {String(comment.post_id).substring(0, 12)}...
                                            </code>
                                        </td>
                                        <td className="text-center">
                                            <button 
                                                onClick={() => handleDelete(comment.id || comment._id)} 
                                                className="px-3 py-2 text-xs font-medium text-white bg-red-500 rounded-md hover:bg-red-600 transition-colors"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CommentsPage;
